
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

require('./countries');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

window.bus = new Vue();

// Put that before your components registration.
Vue.mixin({
    methods: {
        __: function (key) {
            return _.get(window.translations, key, key);
        }
    }
});

import calendar from './components/calendar/index'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/es'
import Vue from 'vue'
import moment from 'moment'

import 'bootstrap/js/src/util'
import 'bootstrap/js/src/modal'
import './vendor/bootstrap-modal-ios/bootstrap-modal-ios.css'
import './vendor/bootstrap-modal-ios/bootstrap-modal-ios.js'
//./components/calendar/vue-event-calendar.vue

var VueTouch = require('vue-touch');
VueTouch.config.swipe = { direction: 'horizontal' };
Vue.use( VueTouch );
Vue.use(calendar, {locale: 'es', weekStartOn: 1, color: '#000'});
Vue.use(ElementUI, { locale })
Vue.prototype.moment = moment

require('./components');

// Provoca errores en IE
// require('./vuex');

const app = new Vue({
    el: '#app',
    data: {
        window: window,
        bus: window.bus,
    }
    // store
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js